export const GET_GAMES = "GET_GAMES";
export const GAMES_ERROR = "GAMES_ERROR";
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
